import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.5 15v1q0 .625.438 1.063.437.437 1.062.437.624 0 1.063-.438.437-.436.437-1.062v-1h1q.624 0 1.063-.438Q16 14.125 16 13.5q0-.624-.438-1.063A1.45 1.45 0 0 0 14.5 12h-1v-1q0-.624-.438-1.063A1.45 1.45 0 0 0 12 9.5q-.624 0-1.063.438A1.45 1.45 0 0 0 10.5 11v1h-1q-.624 0-1.063.438A1.45 1.45 0 0 0 8 13.5q0 .624.438 1.063Q8.875 15 9.5 15zM7 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 19V8q0-.824.588-1.412A1.93 1.93 0 0 1 7 6h10q.824 0 1.413.588Q19 7.175 19 8v11q0 .824-.587 1.413A1.93 1.93 0 0 1 17 21zm0-2h10V8H7zM7 5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 4a.97.97 0 0 1 .287-.712A.97.97 0 0 1 7 3h10q.424 0 .712.288Q18 3.575 18 4c0 .425-.096.52-.288.713A.97.97 0 0 1 17 5z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }